import { PhoneDto, SendPhoneConfirmationDto, VerifyPhoneConfirmationDto, VerifyPhoneConfirmationResultDto } from '.';
import axios from 'axios';

export class ProfileService {
    sendPhoneConfirmation(phone: PhoneDto, recaptchaToken?: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            axios
                .post('/api/bff/profile/phone-confirmation', { phone, recaptchaToken } satisfies SendPhoneConfirmationDto)
                .then(() => resolve())
                .catch(reject);
        });
    }

    verifyPhoneConfirmation(phone: PhoneDto, code: string, recaptchaToken?: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            axios
                .post<VerifyPhoneConfirmationResultDto>('/api/bff/profile/phone-confirmation/verification', {
                    phone,
                    code,
                    recaptchaToken
                } satisfies VerifyPhoneConfirmationDto)
                .then(response => resolve(response.data.verified || false))
                .catch(reject);
        });
    }
}
